import { LEGAL_DOCUMENT_BODY_CLASS } from "./legalDocumentBodyClass";
import { LegalDocumentRevisionFooter } from "./LegalDocumentRevisionFooter";

export function PrivacyContent() {
  return (
    <div className={LEGAL_DOCUMENT_BODY_CLASS}>
      <h1>Политика конфиденциальности</h1>

      <p>
        Настоящая Политика конфиденциальности описывает, какие данные могут
        обрабатываться при использовании сервиса Mom Recipes, в каких целях и на
        каких условиях. Оператором в смысле обработки данных при использовании
        сервиса выступает Индивидуальный предприниматель Иванов Дмитрий
        Вячеславович (контакты — в конце документа).
      </p>

      <h2>1. Какие данные могут собираться</h2>
      <p>
        <strong>Данные профилей и пользования сервисом:</strong> имя или псевдоним,
        возраст (в том числе в месяцах), предпочтения в еде, сведения об аллергиях и
        непереносимостях, иные данные, которые Пользователь сам вносит в профили
        семьи и детей для персонализации рецептов и планов.
      </p>
      <p>
        Пользователь может указывать вымышленные или обезличенные сведения в
        профилях; ответственность за содержание вводимой информации несёт
        Пользователь.
      </p>
      <p>
        <strong>Учётная запись:</strong> адрес электронной почты и иные данные,
        необходимые для регистрации и входа через выбранного провайдера
        аутентификации (Supabase Auth).
      </p>
      <p>
        <strong>Технические и служебные данные:</strong> при обращении к сервису
        автоматически могут обрабатываться, в частности, IP-адрес, сведения об
        устройстве и браузере (User-Agent), время запросов, технические логи
        инфраструктуры, а также сведения о действиях в приложении, если они
        фиксируются для работы сервиса, аналитики, безопасности или отладки (в
        объёме, реально используемом в проекте).
      </p>
      <p>
        Сервис <strong>не предназначен</strong> для самостоятельного сбора
        персональных данных несовершеннолетних: данные детских профилей вводит и
        контролирует совершеннолетний Пользователь как законный представитель.
      </p>

      <h2>2. Зачем используются данные</h2>
      <p>Данные используются, в том числе, для:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>предоставления функций сервиса (рецепты, план, чат, профили семьи);</li>
        <li>персонализации рецептов и рекомендаций с учётом введённых ограничений;</li>
        <li>обработки обращений в поддержку;</li>
        <li>улучшения качества сервиса, аналитики использования и обеспечения безопасности.</li>
      </ul>

      <h2>3. Передача данных третьим лицам</h2>
      <p>
        Для работы сервиса данные могут передаваться и обрабатываться
        техническими подрядчиками и провайдерами: хостинг и база данных (в т.ч.
        Supabase), платёжный оператор (при оплате подписки), поставщики аналитики и
        иные сервисы — <strong>строго в объёме, необходимом для оказания услуг</strong>,
        на основании договоров или публичных оферт таких провайдеров и в
        соответствии с применимым законодательством.
      </p>
      <p>
        Исполнитель не продаёт персональные данные Пользователей третьим лицам в
        рекламных целях.
      </p>

      <h2>4. Хранение, срок хранения и защита</h2>
      <p>
        Исполнитель применяет организационные и технические меры, разумные для
        защиты данных от несанкционированного доступа, утраты или искажения (в
        рамках используемой инфраструктуры и типового веб-приложения). Абсолютная
        безопасность передачи данных в сети Интернет не гарантируется ни одним
        сервисом; Пользователь также несёт ответственность за сохранность своих
        учётных данных.
      </p>
      <p>
        Данные хранятся в течение срока, необходимого для предоставления сервиса,
        исполнения обязательств перед Пользователем, соблюдения требований
        законодательства и разрешения возможных споров. Отдельные данные могут
        сохраняться до удаления учётной записи Пользователем (если техническая
        реализация сервиса это предусматривает) либо в течение срока,
        установленного законом или обоснованно необходимого для защиты законных
        интересов Исполнителя (включая ограниченный объём резервного копирования и
        служебных логов).
      </p>
      <p>
        После утраты необходимости в персональных данных для указанных целей
        Исполнитель удаляет их или обезличивает, если иное не требуется для
        исполнения закона, действующего запроса уполномоченного органа или
        судебного акта.
      </p>

      <h2>5. Права Пользователя</h2>
      <p>
        Пользователь может запросить уточнение обрабатываемых данных, их
        актуализацию или удаление — в пределах, допускаемых технической
        реализацией сервиса и требованиями закона, через контактный email ниже.
      </p>

      <h2>6. Контакты</h2>
      <p>
        Исполнитель: ИП Иванов Дмитрий Вячеславович
        <br />
        Email:{" "}
        <a href="mailto:aiapps.probusiness@gmail.com">aiapps.probusiness@gmail.com</a>
      </p>
      <LegalDocumentRevisionFooter />
    </div>
  );
}
